import React from 'react'
import { IconSize } from '@sidecar-components/atoms/Icon'

export enum TextFieldTypes {
  TEXT = 'text',
  NUMBER = 'number',
  EMAIL = 'email',
  PASSWORD = 'password',
  TEL = 'tel',
  URL = 'url',
  SEARCH = 'search',
}

export interface TextFieldProps {
  autoComplete?: string
  autoFocus?: boolean
  button?: string
  buttonLabel?: string
  buttonSize?: IconSize
  className?: string
  condensed?: boolean
  testId?: string
  disabled?: boolean
  error?: string
  helperText?: string
  icon?: string
  inputMode?: React.HTMLAttributes<HTMLInputElement>['inputMode']
  label: string
  name: string
  onBlur?: React.FocusEventHandler
  onButtonClick?: React.MouseEventHandler<HTMLButtonElement>
  onChange?: React.FormEventHandler
  onFocus?: React.FocusEventHandler
  onKeyDown?: React.KeyboardEventHandler
  maxLength?: number
  pattern?: string
  placeholder?: string
  prefix?: string
  suffix?: string
  textRedacted?: boolean
  type?: TextFieldTypes
  value?: string
}
